import { render, staticRenderFns } from "./PaginaPersonaleMinistero.vue?vue&type=template&id=28394cb1"
import script from "./PaginaPersonaleMinistero.vue?vue&type=script&lang=js"
export * from "./PaginaPersonaleMinistero.vue?vue&type=script&lang=js"
import style0 from "./PaginaPersonaleMinistero.vue?vue&type=style&index=0&id=28394cb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports